import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ShimmerThumbnail } from "react-shimmer-effects";
import Slider from '../../../components/Slider/rough-country-slider';
import DetaileSection from '../../../components/DetailSection/rough-country-details';
import FitmentSection from '../../../components/FitmentSection/rough-country-fitment';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { buildRoughCountryProductSchema } from '../../../utils/productSchema';

export default function Details({ sku, getCartData }) {
    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
    const [productData, setProductData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [itemName, setItemName] = useState("");
    const [itemDescription, setItemDescription] = useState("");
    const [isDataValid, setIsDataValid] = useState(true);


    const navigate = useNavigate();
    const currentLink = window.location.href;
    const url = new URL(currentLink);
    url.search = '';
    const canonicalUrl = url.toString();


    const TEST_REVIEWS = {
        average: 4.5,
        count: 10,
        reviews: [
            {
                author: "Test User",
                rating: 5,
                body: "Test review",
                date: "2026-10-01",
            },
        ],
    };


    useEffect(() => {
        const fetchProductDetails = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`${mainUrl}/api/rough/getRoughCountryProductDetail/${sku}`);

                if (response.data && response.data.data && response.data.data.product) {
                    const product = response.data.data.product;
                    const fitment = response.data.data.fitment || [];

                    setProductData({ product, fitment });
                    setItemName(product.title || `${product.manufacturer} - ${product.sku}`);
                    setItemDescription(
                        `Discover the ${product.title || product.manufacturer} ${product.sku} – ${product.product_description || "high-quality product from Rough Country"
                        }. Perfect for your vehicle needs.`
                    );
                } else {
                    setIsDataValid(false);
                    //Redirect to home if no product found
                    navigate("/", { replace: true });
                }
            } catch (error) {
                console.error("Error fetching Rough Country product:", error);
                setIsDataValid(false);
            } finally {
                setIsLoading(false);
            }
        };
        fetchProductDetails();
    }, [sku]);

    const goBackToHomepage = () => {
        navigate('/');
    };

    const reviewsData = TEST_REVIEWS;

    const productSchema = !isLoading && productData
        ? buildRoughCountryProductSchema(productData.product, { url: canonicalUrl, name: itemName, description: itemDescription, reviewsData })
        : null;

    return (
        <>
            <Helmet>
                <title>{itemName || "Rough Country Product"}</title>
                <meta name="description" content={itemDescription || "Explore premium Rough Country products at Extreme Performance"} />
                <link rel="canonical" href={canonicalUrl} />
                {productSchema && <script type="application/ld+json">{JSON.stringify(productSchema)}</script>}
            </Helmet>

            {isDataValid ? (
                <>
                    <section>
                        <div className="parformane-bar second-bar-p">
                            <div className="container">
                                <ul className="p-0 m-0 listing-parmofamne">
                                    <li><a href="/">Home / </a></li>
                                    <li><a href="/rough-country">Rough Country / </a></li>
                                    <li className="active-bread"><a href="#">{itemName}</a></li>
                                </ul>
                            </div>
                        </div>
                    </section>

                    {/* <div className="details-discount">
                       
                    </div> */}

                    <section className="slider-pernt">
                        <div className="container wheelDetailsContainer">
                            <div className="row">
                                <div className="col-lg-6">
                                    {!isLoading && productData ? (
                                        <Slider data={productData.product} />
                                    ) : (
                                        <ShimmerThumbnail height={572} rounded />
                                    )}
                                </div>

                                <div className="col-lg-6">
                                    {!isLoading && productData ? (
                                        <DetaileSection
                                            data={productData.product}
                                            // fitment={productData.fitment}
                                            setdata={getCartData}
                                        />
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>

                    {!isLoading && productData ? (
                        <FitmentSection
                            fitment={productData.fitment}
                            data={productData.product}
                        />
                    ) : (
                        ""
                    )}


                </>
            ) : (
                <div className="error-screen text-center py-5">
                    <h1>Product Not Found</h1>
                    <p>Sorry, we couldn't find this Rough Country product.</p>
                    <button className="btn btn-sm btn-danger" onClick={goBackToHomepage}>
                        Go back to homepage
                    </button>
                </div>
            )}
        </>
    );
}
